export enum sizes {
    smallest = "Smallest",
    smaller = "Smaller",
    small = "Small",
    medium = "Medium",
    large = "Large",
    larger = "Larger",
    largest = "Largest",
  }
  